export default function Shop() {
  return <h1 className="text-2xl font-bold">Our Products</h1>;
}
